import { AuthActions } from '../store';

export class NetworkService {
  static getRequestOptions(method, body = undefined) {
    const authToken = JSON.parse(sessionStorage.getItem('token'));

    // specify JWT because of Django
    const headers = {
      Authorization: `JWT ${authToken}`,
      'Content-Type': 'application/json',
    };
    if (body) {
      return {
        method,
        headers,
        body,
      };
    }
    return {
      method,
      headers,
    };
  }

  static async fetchWithRetry(dispatch, callback) {
    let response = await callback();

    if (response.status === 401) {
      // if authentication fails, try to refresh the token
      await dispatch(AuthActions.refreshToken());
      response = await callback();
    }

    return response;
  }
}
